import Link from "next/link";
import { useRouter } from "next/router";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { LeftArrow, RightArrow } from "./horizontal-scroll-arrows";
import { useEffect, useRef } from "react";

type scrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

interface Topic {
  name: JSX.Element | string;
  key: string;
  emoji?: string;
  bgActiveClass?: string;
  seoTitle: string;
  seoDescription: string;
}
interface Topics {
  topics: Topic[];
  page?: string;
  hasSearchedData?: boolean;
}

const ExploreTopics: React.FunctionComponent<Topics> = ({
  topics,
  page,
  hasSearchedData,
}) => {
  const router = useRouter();
  const {
    query: { topic },
  } = router;
  const scrollMenuApiRef = useRef({} as scrollVisibilityApiType);

  useEffect(() => {
    // Added an abitrary div to scroll to view when ExploreTopics is in sticky position
    setTimeout(() => {
      if (topic && scrollMenuApiRef.current) {
        // Added an abitrary div to scroll to view when ExploreTopics is in sticky position
        const el = document.getElementById("explore-topic-scroll-target");
        el.scrollIntoView(true);
        scrollMenuApiRef.current.scrollToItem(
          scrollMenuApiRef.current.getItemElementById(topic as string),
          "smooth",
          "center"
        );
      }
    }, 100);
  }, [topic, scrollMenuApiRef]);

  return (
    <ScrollMenu
      LeftArrow={LeftArrow}
      RightArrow={RightArrow}
      apiRef={scrollMenuApiRef}
      transitionDuration={500}
      transitionBehavior={"smooth"}
      itemClassName="!ml-1 flex"
      scrollContainerClassName={"pt-4 pb-6 -ml-4"}
    >
      {topics.map(({ name, key, emoji, bgActiveClass = undefined }) => (
        <TopicTab
          itemId={key}
          key={key}
          route={key}
          active={topic ? key === topic : key === topics[0].key}
          bgActiveClass={bgActiveClass}
          page={page}
          hasSearchedData={hasSearchedData}
        >
          {name} {emoji}
        </TopicTab>
      ))}
    </ScrollMenu>
  );
};

const TopicTab = ({
  itemId,
  children,
  route,
  textActiveClass = "text-white",
  textInactiveClass = "text-primary2",
  bgActiveClass = "bg-primary",
  bgInactiveClass = "bg-secondary",
  active,
  page,
  hasSearchedData,
}) => {
  return (
    <Link
      replace
      scroll={false}
      href={
        page == "news-stack"
          ? `/news-stack?topic=${route}`
          : `/news?topic=${route}`
      }
      passHref
    >
      <a className="mr-3" id={itemId}>
        <div
          className={`rounded-2xl ${
            hasSearchedData
              ? bgInactiveClass
              : active
              ? bgActiveClass
              : bgInactiveClass
          } px-4 py-2`}
        >
          <span
            className={`whitespace-nowrap font-sen ${
              hasSearchedData
                ? textInactiveClass
                : active
                ? textActiveClass
                : textInactiveClass
            }`}
          >
            {children}
          </span>
        </div>
      </a>
    </Link>
  );
};

export default ExploreTopics;
